import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Form} from 'antd';
import {layout} from "icsoc-antd-ex";
import UnionComponent from 'Components/union/unionComponent';
// 查询
import Query from "./Query";
// 图表
import ChartItem from "./Chart";

const {BaseContentMainHeader} = layout;
class Monitoring extends UnionComponent{
  constructor(props){
    super(props);
    this.state={

    }
  }
  render() {
    return(
      <div style={{paddingBottom:30}}>
         <BaseContentMainHeader title="项目关键指标分钟监控图 "></BaseContentMainHeader>
         <Query/>
         <ChartItem />
      </div>
    )
  }
}
export default Form.create()(Monitoring);